import axios from '@axios'

/** 
* Índice
* {@link getInvoices} - Obtener facturas
* {@link getInvoice} - Obtener factura
* {@link addInvoice} - Crear factura
* {@link deleteInvoice} - Eliminar factura
* {@link updateInvoice} - Actualizar factura
* {@link sendEmail} - Enviar mail factura
* {@link downloadInvoice} - Obtener pdf factura
* {@link downloadTicket} - Obtener pdf ticker
* {@link convertIntoInvoice} - Convertir un ticket en factura
* {@link makeCorrectiveInvoice} - Rectificar una factura/recibo
*/

    /**
     * 
     * @param {*} queryParams 
     * @returns invoices 
     */
    export const getInvoices = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/invoices', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }
    export const getInvoice = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/invoices/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    export const addInvoice = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/invoices`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }
    export const deleteInvoice = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/invoices/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }
    export const updateInvoice = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/invoices/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    export const sendEmail = function (data)  {
        try {
            return new Promise((resolve, reject) =>
            {
                axios
                    .post('/send-invoice',  data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })    
        } catch (error) {
            return error
        }
            
    }
    export const downloadInvoice = function (data)  {
        try {
            return new Promise((resolve, reject) =>
            {
                axios
                    .post('/download-invoice',  data,{ responseType: 'arraybuffer' })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })    
        } catch (error) {
            return error
        }
            
    }

    export const downloadTicket = function (data)  {
        try {
            return new Promise((resolve, reject) =>
            {
                axios
                    .post('/download-receipt',  data,{ responseType: 'arraybuffer' })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })    
        } catch (error) {
            return error
        }
            
    }

    export const convertIntoInvoice = function (id) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/convert-invoice/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    export const existsFacE = function (id) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/exists-fac-e/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    export const deleteExistingFacE = function (id) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/delete-fac-e/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    export const makeCorrectiveInvoice = function (invoice) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`invoice/corrective-invoice`, invoice)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
                })

        } catch (error) {
            return error
        }
    }




